import {dispatch} from 'od-modules/secure_store/store';
import {
    SET_SHOPPING_CART,
    SET_PRIME_MEMBER_SELECTED,
} from 'od-modules/secure_store/actions';

export default {
    getUrl() {
        return Odigeo.Settings.getProperty('membershipServiceFormatter')('update-membership-subscription');
    },
    getMethod() {
        return 'POST';
    },
    requestSuccess(response) {
        if (response !== null) {
            dispatch({type: SET_SHOPPING_CART, entry: response});
            if (!response.membershipPerksDTO) {
                dispatch({
                    type: SET_PRIME_MEMBER_SELECTED, entry: {
                        isSubscriptionAdded: false,
                        fareSelected: 'nonPrime',
                    }, merge: true});
            }
            Odigeo.trigger('update-membership-subscription:success', response);
        }
        return response;
    },

    requestError(response) {
        dispatch({type: SET_PRIME_MEMBER_SELECTED, entry: {
            fail: {
                error: true,
                message: 'UpdateMembershipSubscriptionFail',
            },
        }, merge: true});

        Odigeo.trigger('update-membership-subscription:fail', response);
        return null;
    },

    getFareSelected(data) {
        return (data && data.fareSelected) || '';
    },

    getQuantity(data) {
        return data && data.isSubscriptionAdded ? 1 : 0;
    },

    getTravellerId(data) {
        return (data && data.travellerId) || 0;
    },

    buildRequestData(data) {
        return {
            travellerId: this.getTravellerId(data),
            quantity: this.getQuantity(data),
            fareSelected: this.getFareSelected(data),
        };
    },

    formatData(request) {
        return this.buildRequestData(request);
    },
};
